// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"27":"e046c595","348":"333611b8","546":"2d310c6c","558":"f412a13f","571":"1ba0ec4b"}[chunkId] + ".chunk.js";
};